import React from "react";

import "../../utilities.css"
import "./QuickLinks.css";

const QuickLinks = ({quickLinks}) => {
    return (
      <div className="quicklinks-container">
        {quickLinks.sort((item1, item2) => {return (item1.rank - item2.rank)}
          ).map((item) => {
            return (
            <a key={item.id} href={item.type + item.link} className="quicklinks">
                <h4 className="quicklinks-des">{item.description}</h4>
                <hr className="quicklinks-hr" />
                <div className="quicklinks-link">{item.link}</div>
            </a>
          )}
        )
        }
      </div>
    )
}

export default QuickLinks;